/* ============================================================
   MONNAIE DU MONDE — global.js
   Carrousels, révélation au scroll, slideshow, texte dynamique,
   tiroir mobile, ajout panier AJAX avec limites, toast.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- toast ---------- */
  var toastTimer = null;
  /* mdmToast(html, {duree}) : message court (pastille) ou long (carte sur plusieurs lignes, durée adaptée à la longueur) */
  window.mdmToast = function (html, opts) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.innerHTML = html;
    var longueur = (t.textContent || '').length;
    t.classList.toggle('toast--long', longueur > 42);
    t.classList.add('visible');
    clearTimeout(toastTimer);
    var duree = (opts && opts.duree) || Math.min(9000, Math.max(3200, longueur * 55));
    toastTimer = setTimeout(function () { t.classList.remove('visible'); }, duree);
  };

  /* ---------- compteur panier ---------- */
  window.mdmMajBulle = function (n) {
    var b = document.getElementById('bulle-panier');
    if (!b) return;
    b.textContent = n;
    b.classList.toggle('visible', n > 0);
  };

  /* ---------- carrousels (flèches) ---------- */
  window.mdmInitCarrousels = function (racine) {
    (racine || document).querySelectorAll('[data-defile]').forEach(function (b) {
      if (b.dataset.lie) return;
      b.dataset.lie = '1';
      b.addEventListener('click', function () {
        var piste = document.getElementById(b.dataset.defile);
        if (!piste) return;
        var carte = piste.querySelector('.carte');
        var pas = (carte ? carte.getBoundingClientRect().width + 22 : 300) * Math.sign(+b.dataset.sens);
        piste.scrollBy({ left: pas, behavior: 'smooth' });
      });
    });
  };

  /* ---------- révélation au scroll (avec garde-fou) ---------- */
  window.mdmInitReveal = function (racine) {
    var els = Array.prototype.slice.call((racine || document).querySelectorAll('.reveal:not(.vu)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vu'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('vu'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('vu'); }); }, 2400);
  };

  /* ---------- ajout panier AJAX (respecte la limite par produit) ---------- */
  /* quantités déjà au panier : de la variante, et du produit entier (limite « 1 par personne ») */
  function qteEnPanier(varianteId, produitId) {
    return fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var qte = 0, qteProduit = 0;
        panier.items.forEach(function (i) {
          if (i.variant_id === +varianteId) qte += i.quantity;
          if (produitId && i.product_id === +produitId) qteProduit += i.quantity;
        });
        return { qte: qte, qteProduit: qteProduit || qte, total: panier.item_count };
      });
  }

  /* options d'ajout lues sur le bouton : data-limite, data-un-par-personne, data-deja-commande, data-produit-id,
     data-msg-deja-panier, data-msg-deja-commande (posés par snippets/limite-achat.liquid, mode « attributs ») */
  window.mdmOptionsAjout = function (el) {
    var d = (el && el.dataset) || {};
    return {
      produitId: d.produitId,
      unParPersonne: d.unParPersonne === 'true',
      dejaCommande: +d.dejaCommande || 0,
      msgDejaPanier: d.msgDejaPanier,
      msgDejaCommande: d.msgDejaCommande,
      bouton: el
    };
  };

  /* micro-interaction de confirmation : la pièce tombe dans le bouton (fiche) / pulsation (cartes), le panier de l'en-tête réagit */
  window.mdmAnimerAjout = function (el) {
    var bulle = document.getElementById('bulle-panier');
    if (bulle) {
      bulle.classList.remove('mdm-pulse');
      void bulle.offsetWidth;
      bulle.classList.add('mdm-pulse');
      setTimeout(function () { bulle.classList.remove('mdm-pulse'); }, 800);
    }
    if (!el || !el.classList) return;
    var fiche = el.hasAttribute('data-bouton-achat');
    if (fiche && !el.hasAttribute('data-animer')) return;
    var classe = fiche ? 'est-ajoute' : 'mdm-ajoute';
    el.classList.remove(classe);
    void el.offsetWidth;
    el.classList.add(classe);
    clearTimeout(el._animAjout);
    el._animAjout = setTimeout(function () { el.classList.remove(classe); }, fiche ? 1900 : 800);
  };

  /* mdmAjouter(variante, limite, libelle, opts) → Promise<boolean>
     opts : { produitId, unParPersonne, dejaCommande, msgDejaPanier, msgDejaCommande, bouton } (voir mdmOptionsAjout).
     « 1 par personne » : refuse si la pièce est déjà au panier OU déjà commandée par ce client (toast explicite). */
  window.mdmAjouter = function (varianteId, limite, libelleProduit, opts) {
    opts = opts || {};
    return qteEnPanier(varianteId, opts.produitId).then(function (etat) {
      var textes = window.mdm.textes || {};
      if (opts.unParPersonne) {
        if ((+opts.dejaCommande || 0) >= 1) {
          window.mdmToast(opts.msgDejaCommande || textes.dejaCommande || 'Vous avez déjà commandé cette pièce : elle est limitée à 1 exemplaire par personne.');
          return false;
        }
        if (etat.qteProduit >= 1) {
          window.mdmToast(opts.msgDejaPanier || textes.dejaPanier || 'Limité à 1 exemplaire par personne — cette pièce est déjà dans votre panier.');
          return false;
        }
      } else if (etat.qte >= limite) {
        var msg = (textes.limiteAtteinte || 'Quantité limitée à [limite] — pour des quantités plus importantes, contactez-nous à [email]')
          .replace('[limite]', limite).replace('[email]', window.mdm.emailContact || '');
        window.mdmToast(msg);
        return false;
      }
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: +varianteId, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.mdmMajBulle(etat.total + 1);
        window.mdmToast('' + (textes.ajoutOk || 'Ajouté au panier') +
          (libelleProduit ? ' — ' + libelleProduit : ''));
        window.mdmAnimerAjout(opts.bouton);
        return true;
      });
    }).catch(function () {
      window.mdmToast('Une erreur est survenue — réessayez.');
      return false;
    });
  };

  window.mdmInitAjouts = function (racine) {
    (racine || document).querySelectorAll('[data-ajout]').forEach(function (b) {
      if (b.dataset.lie) return;
      b.dataset.lie = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        window.mdmAjouter(b.dataset.ajout, +(b.dataset.limite || 10) || 10, undefined, window.mdmOptionsAjout(b));
      });
    });
  };

  /* ---------- menus déroulants (remplacent les <select data-deroulant>) ----------
     Bouton + listbox ARIA : clavier (flèches, Entrée, Échap, Début/Fin),
     clic extérieur, synchronisation du select caché (change dispatché). */
  window.mdmInitDeroulants = function (racine) {
    (racine || document).querySelectorAll('select[data-deroulant]').forEach(function (sel) {
      if (sel.dataset.lie) return;
      sel.dataset.lie = '1';

      var wrap = document.createElement('div');
      wrap.className = 'deroulant';
      sel.parentNode.insertBefore(wrap, sel);
      wrap.appendChild(sel);
      sel.hidden = true;
      sel.setAttribute('aria-hidden', 'true');
      sel.tabIndex = -1;

      var bouton = document.createElement('button');
      bouton.type = 'button';
      bouton.className = 'deroulant__bouton';
      bouton.setAttribute('aria-haspopup', 'listbox');
      bouton.setAttribute('aria-expanded', 'false');
      if (sel.getAttribute('aria-label')) bouton.setAttribute('aria-label', sel.getAttribute('aria-label'));

      var libelle = document.createElement('span');
      var chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      chevron.setAttribute('class', 'deroulant__chevron');
      chevron.setAttribute('width', '11'); chevron.setAttribute('height', '7');
      chevron.setAttribute('viewBox', '0 0 11 7'); chevron.setAttribute('fill', 'none');
      chevron.innerHTML = '<path d="M1 1l4.5 4.5L10 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
      bouton.appendChild(libelle);
      bouton.appendChild(chevron);

      var panneau = document.createElement('div');
      panneau.className = 'deroulant__panneau';
      panneau.setAttribute('role', 'listbox');

      var options = [];
      Array.prototype.forEach.call(sel.options, function (o, i) {
        if (o.disabled && o.value === '') return; /* placeholder */
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'deroulant__option';
        b.setAttribute('role', 'option');
        b.dataset.valeur = o.value;
        b.dataset.index = i;
        b.innerHTML = '<span>' + o.textContent + '</span><span class="coche">✓</span>';
        b.addEventListener('click', function () { choisir(i); fermer(true); });
        panneau.appendChild(b);
        options.push(b);
      });

      wrap.appendChild(bouton);
      wrap.appendChild(panneau);

      var vise = -1;
      function majLibelle() {
        var o = sel.options[sel.selectedIndex];
        libelle.textContent = o ? o.textContent : '';
        options.forEach(function (b) {
          b.setAttribute('aria-selected', String(+b.dataset.index === sel.selectedIndex));
        });
      }
      function choisir(i) {
        if (sel.selectedIndex === i) return;
        sel.selectedIndex = i;
        majLibelle();
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      function ouvrir() {
        wrap.classList.add('ouvert');
        bouton.setAttribute('aria-expanded', 'true');
        vise = options.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; });
        viser(vise);
      }
      function fermer(focus) {
        wrap.classList.remove('ouvert');
        bouton.setAttribute('aria-expanded', 'false');
        viser(-1);
        if (focus) bouton.focus();
      }
      function viser(i) {
        vise = i;
        options.forEach(function (b, j) { b.classList.toggle('vise', j === i); });
        if (i >= 0) options[i].focus();
      }
      bouton.addEventListener('click', function () {
        wrap.classList.contains('ouvert') ? fermer(false) : ouvrir();
      });
      wrap.addEventListener('keydown', function (e) {
        var ouvert = wrap.classList.contains('ouvert');
        if (e.key === 'Escape' && ouvert) { e.preventDefault(); fermer(true); }
        else if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') ) {
          e.preventDefault();
          if (!ouvert) { ouvrir(); return; }
          var d = e.key === 'ArrowDown' ? 1 : -1;
          viser((vise + d + options.length) % options.length);
        }
        else if (e.key === 'Home' && ouvert) { e.preventDefault(); viser(0); }
        else if (e.key === 'End' && ouvert) { e.preventDefault(); viser(options.length - 1); }
        else if (e.key === 'Enter' && ouvert && document.activeElement !== bouton) {
          e.preventDefault();
          if (vise >= 0) { choisir(+options[vise].dataset.index); fermer(true); }
        }
        else if (e.key === 'Tab' && ouvert) fermer(false);
      });
      document.addEventListener('pointerdown', function (e) {
        if (wrap.classList.contains('ouvert') && !wrap.contains(e.target)) fermer(false);
      });

      majLibelle();
    });
  };

  /* Bannière défilante : assets/slideshow.js · texte dynamique : assets/rotateur.js
     (chargés par leurs sections, compatibles éditeur de thème). */

  /* méga-menus, menu Monde, tiroir mobile et recherche mobile : voir assets/entete.js (chargé par la section header) */

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    window.mdmInitCarrousels(document);
    window.mdmInitReveal(document);
    window.mdmInitAjouts(document);
    window.mdmInitDeroulants(document);
  });

  /* Rafraîchissements de l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) {
    window.mdmInitCarrousels(e.target);
    window.mdmInitReveal(e.target);
    window.mdmInitAjouts(e.target);
    window.mdmInitDeroulants(e.target);
  });
})();
